/* eslint-disable no-unused-vars */
export enum HOME_EXPERIMENT_LOCATIONS {
  ALL = "all",
  ARROW = "arrow",
  CART = "cart",
  FAVORITE = "favorite",
  CARD = "card",
  FILTER = "filter",
}
